// extracted by css-extract-rspack-plugin
export default {"cls1":"JJHomePageSearch-cls1_meM","cls2":"JJHomePageSearch-cls2_m3p JJHomePageSearch-cls1_meM"};